/**
 * Created by andrey on 18.05.2026
 */

const EditorCommandLogEntryView = cleverapps.Layout.extend({
    ctor: function (entry, index, commandLog) {
        const styles = cleverapps.styles.EditorCommandLogEntryView;

        const label = cleverapps.UI.generateOnlyText(
            `${entry.time} ${entry.userId} ${entry.text}`,
            cleverapps.styles.FONTS.ADMIN_LOG_FONT
        );
        label.setDimensions(styles.width - styles.padding * 2, styles.height);
        label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);

        const totalHeight = label.height + styles.padding * 2;

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize(styles.width, totalHeight);
        container.addChild(label);
        label.setAlignment(styles.width / 2, totalHeight / 2);

        this._super([container], {
            direction: cleverapps.UI.HORIZONTAL
        });

        const bg = cleverapps.UI.createScale9Sprite(index % 2 === 0
            ? bundles.admin.frames.row_even_bg : bundles.admin.frames.row_odd_bg);
        bg.setContentSize(this.getContentSize());
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg, -1);

        const strikeLine = this.strikeLine = new cc.DrawNode();
        const lineY = styles.padding + label.height / 2;
        strikeLine.drawSegment(
            cc.p(styles.padding, lineY),
            cc.p(this.width - styles.padding, lineY),
            1,
            cc.color(0, 0, 0, 200)
        );
        strikeLine.setVisible(entry.undone);
        this.addChild(strikeLine, 1);

        commandLog.on("entryUpdated", (updated) => {
            if (updated === entry) {
                strikeLine.setVisible(entry.undone);
            }
        }, this);
    }
});

cleverapps.styles.EditorCommandLogEntryView = {
    width: 370,
    height: 30,
    padding: 6
};
